// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__iAJdd","label":"PriceFilterPopup_label__A1r3u","labelSelected":"PriceFilterPopup_labelSelected__3SX1p"};